import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

const FooterColumn = ({header = '', body = '', isTotal = false}) => {
	return (
		<StyledFooterColumn className="footer-column-wrapper">
			<OutputText h4 className="footer-header" title={header} ellipsis>
				{header}
			</OutputText>
			<OutputText
				body3
				light={!isTotal}
				className={classNames('footer-body', {lighter: !isTotal})}
				title={body}
				ellipsis
			>
				{body}
			</OutputText>
		</StyledFooterColumn>
	);
};

export default FooterColumn;

FooterColumn.propTypes = {
	header: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	body: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isTotal: PropTypes.string
};

const StyledFooterColumn = styled.div`
	display: flex;
	flex-flow: column;
	.lighter {
		color: var(--neutrals-700);
	}
`;
